import { PropsWithChildren, ReactNode, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

interface Props extends PropsWithChildren {
    title: string;
    summary?: ReactNode;
    defaultOpen?: boolean;
}

export default function MeasureSection({
    title,
    summary,
    defaultOpen = false,
    children,
}: Props) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <details
            open={open}
            onToggle={(event) => setOpen(event.currentTarget.open)}
            onInvalidCapture={(event) => {
                const section = event.currentTarget;
                section.open = true;
                setOpen(true);
            }}
            className="group border-t border-gray-200"
        >
            <summary className="flex cursor-pointer list-none items-center gap-2 py-3 text-sm focus-visible:outline-indigo-600 [&::-webkit-details-marker]:hidden">
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className="size-3 shrink-0 transition-transform group-open:rotate-180"
                />
                <span className="font-medium">{title}</span>
                <span className="ml-auto min-w-0 text-right text-xs text-gray-500">
                    {summary}
                </span>
            </summary>
            <div className="pb-3">{children}</div>
        </details>
    );
}
